import React, { useState, useEffect } from 'react'
import { handleKlaviyoBIS, handleAddToKlaviyoList } from '../../helpers/global'
import { createPortal } from 'react-dom'
import Modal from '../molecules/Modal'

interface KlaviyoBISProps {
  productTitle: string
  variantID: number | string
  comingSoon?: boolean
  limitedEdition?: boolean
  klaviyoAPIKey: string
  limitedEditionList: string
  emailList: string
  variantTitle?: string
  isModalOpen: boolean
  closeModal: () => void
}

const KlaviyoBISForm: React.FC<KlaviyoBISProps> = ({ productTitle, variantID,comingSoon, klaviyoAPIKey,variantTitle, isModalOpen, closeModal, limitedEdition, limitedEditionList, emailList }) => {
  const [email, setEmail] = useState('');
  const [submitMessage, setSubmitMessage] = useState(false);
  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        const modal = document.getElementById('klaviyo-bis-modal');
        if (modal) {
          modal.focus();
        }
      }, 100); // Increased timeout to ensure modal is fully rendered
      return () => clearTimeout(timer);
    }
  }, [isModalOpen]);
  // const [isError, setIsError] = useState(false);
  const handleLimitedEditionSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleAddToKlaviyoList(email, limitedEditionList, klaviyoAPIKey)
    setEmail("");
    setSubmitMessage(true);
  };

  const handleSubmitClick = (e: React.FormEvent<HTMLFormElement>) =>{
    e.preventDefault()
    handleKlaviyoBIS(klaviyoAPIKey, variantID, email, emailList)
    setEmail("");
    setSubmitMessage(true);
  }
  return createPortal (
    <>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="bg-white min-h-80 rounded-lg max-w-md" id="klaviyo-bis-modal" role="dialog" aria-modal="true" aria-label="Back in stock sign up form" aria-expanded="true" tabIndex={-1}>
          <a onClick={closeModal} aria-label="Close Back In Stock Modal"></a>
          <form onSubmit={limitedEdition ? handleLimitedEditionSubmit : handleSubmitClick} className="flex flex-col justify-center m-4 h-full">
            {submitMessage && (
              <p className="body-md p-6 text-center mt-24">{limitedEdition ? window.DEPT.Strings.product.limitedEditionModalSubmitMessage : comingSoon ? window.DEPT.Strings.product.comingSoonModalSubmitMessage : window.DEPT.Strings.product.soldOutModalSubmitMessage}</p>
            )}
            {!submitMessage && (
              <div className="my-4">
                <p className="h2 font-appleGaramond mb-4">{comingSoon ? 'Coming Soon' : limitedEdition ? window.DEPT.Strings.product.limitedEditionModalTitle : window.DEPT.Strings.product.soldOut}</p>
                <p className="body-sm mb-2">{comingSoon ? window.DEPT.Strings.product.comingSoonModalDescription : limitedEdition ? window.DEPT.Strings.product.limitedEditionModalDescription : window.DEPT.Strings.product.soldOutModalDescription }</p>
                {!limitedEdition && (
                  <>
                    <p className="body-xs mb-1 font-bold">{productTitle}</p>
                    {variantTitle && <p className="body-xs mb-4 font-bold">{variantTitle}</p>}
                  </>
                )}
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className="rounded-full bg-white border border-gray-300 shadow-input w-full mb-4"
                />
                <button type="submit" className="button button--primary w-full">
                  <div className="rectangle-1"></div>
                  <div className="button-text">
                    {window.DEPT.Strings.product.notifyMe}
                  </div>
                </button>
              </div>
            )}
          </form>
        </div>
      </Modal>
    </>,
    document.body,
  );
}

export default KlaviyoBISForm